import '@sparkdotfi/app/fonts'
import '@sparkdotfi/app/sentry'
import './css/main.css'

import { MiniappApp, TopLevelErrorBoundary } from '@sparkdotfi/app'
import React from 'react'
import ReactDOM from 'react-dom/client'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TopLevelErrorBoundary>
      <MiniappApp />
    </TopLevelErrorBoundary>
  </React.StrictMode>,
)
